import { render } from "./RoaStchicken.vue?vue&type=template&id=028f24f2"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/RoaStchicken.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "028f24f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('028f24f2', __exports__)) {
    api.reload('028f24f2', __exports__)
  }
  
  module.hot.accept("./RoaStchicken.vue?vue&type=template&id=028f24f2", () => {
    api.rerender('028f24f2', render)
  })

}


export default __exports__